module.exports = __webpack_public_path__ + "img/avatar6.00813dbf.png";